// extracted by mini-css-extract-plugin
export var card = "_4e-0";
export var content = "_4e-1";
export var contentLoading = "_4e-2";